export const option_line = {
  color: ['#37A2FF', '#FF0087'],
  tooltip: {
    trigger: 'axis',
    backgroundColor: '#fff',
    extraCssText: 'box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);',
    borderRadius: 5,
    padding: [10, 20, 10, 20],
    textStyle: {
      color: '#666',
      fontSize: 14
    },
    position: function(pt) {
      return [pt[0], '10%']
    }
  },

  legend: {
    show: true,
    bottom: '5%',
    left: 'center'
  },
  title: {
    left: 'center',
    text: '平台年度活跃数',
    show: false
  },
  xAxis: {
    type: 'category',
    data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    axisTick: {
      alignWithLabel: true
    }
  },
  yAxis: {
    type: 'value',
    axisLine: {
      show: false
    },
    axisTick: {
      show: false
    }
  },
  series: [
    {
      name: 'APP用户',
      label: {
        show: true,
        position: 'top'
      },
      data: [150, 230, 224, 218, 135, 147, 260, 224, 218, 135, 135, 147],
      type: 'line'
    },
    {
      name: '平台用户',
      label: {
        show: true,
        position: 'top'
      },
      data: [218, 135, 147, 260, 150, 230, 224, 135, 147, 224, 218, 135],
      type: 'line'
    }
  ]
}

export const countList = [
  { text: '平台医生总量', key: 'totalDoctor', count: 0 },
  { text: '年度活跃用户总量', key: 'yearTotalActives', count: 0 },
  { text: '年度APP活跃用户总量', key: 'yearTotalAppActives', count: 0 },
  { text: '会员总存续人数', key: 'vipTotalCX', count: 0 },
  { text: '认证用户总数', key: 'authTotal', count: 0 }
]

export const funnelData = [
  { value: 0, key: 'totalActives', name: '平台活跃用户数量' },
  { value: 0, key: 'appActives', name: 'APP活跃用户数量' },
  { value: 0, key: 'latentes', name: '高潜用户数量（学习时间>5分钟）' },
  { value: 0, key: 'orders', name: '提交订单用户数量' },
  { value: 0, key: 'successOrders', name: '用户付费数量' },
  { value: 0, key: 'vipYears', name: '年卡VIP数量' }
]
export const option_funnel = {
  title: {
    left: 'center',
    text: '会员销售漏斗',
    show: false
  },
  color: ['#37A2FF', '#FFBF00', '#fc8452', '#ea7ccc', '#9a60b4', '#FF0087'],
  tooltip: {
    trigger: 'item',
    backgroundColor: '#fff',
    extraCssText: 'box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);',
    borderRadius: 5,
    padding: [10, 20, 10, 20],
    textStyle: {
      color: '#666',
      fontSize: 14
    }
  },
  legend: {
    show: false
  },
  series: [
    {
      type: 'funnel',
      left: '30%',
      width: '60%',
      min: 0,
      max: 100000,
      minSize: '0%',
      maxSize: '100%',
      sort: 'none',
      gap: 2,
      label: {
        show: true,
        position: 'inside',
        formatter: '{c}'
      },
      itemStyle: {
        borderColor: '#fff',
        borderWidth: 1
      },
      emphasis: {
        label: {
          fontSize: 20
        }
      },
      data: funnelData
    },
    {
      type: 'funnel',
      left: '30%',
      width: '60%',
      min: 0,
      max: 100000,
      minSize: '0%',
      maxSize: '100%',
      sort: 'none',
      gap: 2,

      label: {
        show: true,
        position: 'left',
        align: 'left',
        formatter: '{b}'
      },
      itemStyle: {
        borderColor: '#fff',
        borderWidth: 1
      },
      emphasis: {
        label: {
          fontSize: 20
        }
      },
      data: funnelData
    }
  ]
}



// WEBPACK FOOTER //
// ./src/views/databaseAnlysis/userDataBoard/options.js